var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAmazonAwslambdaIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "22.34 10.9 64 64",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.17 42.916l-5.957-20.484-3.377 1.688v37.527l3.377 1.657z",
    fill: "#9d5125"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.212 63.304l6.53-1.53V23.993l-6.53-1.53z",
    fill: "#f58534"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.408 42.916l-6.18 24.912-4.97-2.485V20.425l4.97-2.485z",
    fill: "#9d5125"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.228 17.94l10.13 3.25v43.325l-10.13 3.218z",
    fill: "#f58534"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M77.468 57.76l-4.078-.223V26.7h4.078z",
    fill: "#9d5125"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M77.15 26.7l.446 3.982-4.1.573-15.833-4.1L62.2 24.8z",
    fill: "#6b3b19"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M77.723 55.085l-4.1-.573-15.833 4.1 4.556 2.357z",
    fill: "#fcbf92"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#9d5125"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.083 32.658l-8.155 1.083v18.286l8.155 1.083z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.126 42.852L54.34 10.9l-7.932 3.95v56.068l7.932 3.95z"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M77.468 55.15l-15.196 4.556v-33.64l15.196 4.556zM54.34 10.9v64l26.505-13.252V24.152zm12.743 42.274l8.442-10.258-8.442-10.258z",
    fill: "#f58534"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmazonAwslambdaIcon);
export default __webpack_public_path__ + "static/media/amazon_awslambda-icon.788a1048a19255af49fda2cdf914c8d0.svg";
export { ForwardRef as ReactComponent };